/**
 * Created by vlad on 27.12.18.
 */

DogCell.prototype.hurtDuration = function () {
    return 0.8;
};